import { _ } from "../../polyglot/polyglot.js";
import { formatAsLongDate } from "../../helpers/date-formatting-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import Timespan from "../../../models/period/Timespan.js";

/**
 * `ConfigureImportDataSummaryWidget` renders a table showing a
 * summary of import data (e.g., company name, dates, number of
 * transactions, …).
 */
export default class ConfigureImportDataSummaryWidget extends Widget {
	constructor({ importData }) {
		super(...arguments);

		this._companyName = undefined;
		this._businessIdentityCode = undefined;
		this._fiscalYears = undefined;
		this._lastTransactionDate = undefined;
		this._accounts = undefined;
		this._transactions = undefined;

		const companyInfo = importData.importCompanyInfo;

		this._companyName = companyInfo.companyName;
		this._businessIdentityCode = companyInfo.businessIdentityCode;

		this._fiscalYears = companyInfo.fiscalYears || {};

		this._lastTransactionDate = companyInfo.lastTransactionDate;
		this._accounts = companyInfo.totalNumberOfAccounts;
		this._transactions = companyInfo.totalNumberOfTransactions;
	}

	renderContentOn(html) {
		html.table(
			{
				klass: "table table-striped table-bordered",
				"data-test": "import-summary",
			},
			html.tbody(
				this._formattedData().map((entry) => (html) => {
					html.tr(
						html.td({ klass: "font-light" }, entry.name),
						html.td({ klass: "font-medium" }, entry.value),
					);
				}),
			),
		);
	}

	_formattedData() {
		return [
			{
				name: _("Company name"),
				value: this._companyName || "-",
			},
			{
				name: _("Business identity code"),
				value: this._businessIdentityCode || "-",
			},
			{
				name: _("Fiscal years"),
				value: this._fiscalYears.map((fiscalYear) =>
					this._formatYear(fiscalYear),
				),
			},
			{
				name: _("Last transaction date"),
				value: formatAsLongDate(this._lastTransactionDate) || "-",
			},
			{
				name: _("Accounts"),
				value: this._accounts || "-",
			},
			{
				name: _("Transactions"),
				value: this._transactions || "-",
			},
		];
	}

	_formatYear(fiscalYear) {
		const timespan = new Timespan({
			start: fiscalYear.start,
			end: fiscalYear.end,
		});

		return (html) => html.div(timespan.toSmartString());
	}
}
